module.exports = __webpack_public_path__ + "img/img30.ec628391.png";